import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";
import { MARKETING_LINKS } from "./constants";

// Marketing nav for the landing page only. It sits over the hero video, so it
// is dark and transparent; the app shell keeps the shared white Navbar.
export default function HomeNav() {
  const { t } = useTranslation(["common", "pages"]);

  return (
    <nav
      aria-label={t("common:navigation.siteNav")}
      className="relative z-10 mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4 text-white"
    >
      <Link
        to="/"
        className="flex items-center gap-2.5 text-[15px] font-bold tracking-[-0.02em]"
      >
        <span
          aria-hidden="true"
          className="inline-block h-2.5 w-2.5 -skew-x-12 rounded-[2px] bg-primary-500"
        />
        Race Manager
      </Link>

      <ul className="hidden items-center gap-7 text-sm text-gray-400 md:flex">
        {MARKETING_LINKS.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className="transition-colors hover:text-white">
              {t(link.labelKey)}
              {"badgeKey" in link && (
                <sup className="ml-1.5 font-mono text-[9px] tracking-[0.08em] text-primary-400">
                  {t(link.badgeKey)}
                </sup>
              )}
            </Link>
          </li>
        ))}
      </ul>

      <div className="flex items-center gap-2">
        <LanguageSwitcher tone="dark" />
        <Link
          to="/login"
          className="inline-flex items-center rounded-full border border-gray-700 px-4 py-2 text-sm font-semibold text-gray-200 transition-colors hover:border-gray-500 hover:text-white"
        >
          {t("pages:home.signIn")}
        </Link>
      </div>
    </nav>
  );
}
